import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import ExpandIcon from './ExpandIcon';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import Checkbox from '@adsk/bim360-matrix-react-checkbox';
import { getNodeForRender, updateNode } from './helpers/nodeHelpers';
import { treeSelectionNodeShape } from './helpers/TreeSelectionPropTypes';
import './_TreeNode.scss';

class TreeNode extends React.PureComponent {
  constructor(props) {
    super(props);

    this.renderSideItems = this.renderSideItems.bind(this);
    this.renderToggle = this.renderToggle.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onSelect = this.onSelect.bind(this);
  }

  renderSideItems() {
    const { sideItems, id } = this.props.node;
    return (
      <div className="TreeNode__container-options" key={`node-${id}-side-item`}>
        {sideItems.map((sideItem, index) => {
          return React.cloneElement(sideItem, { key: `sideItem-${index}` });
        })}
      </div>
    );
  }

  renderToggle(props) {
    return <ExpandIcon {...props} onExpand={this.onToggle} />;
  }

  onToggle() {
    const { onChange, onToggleClick, node } = this.props;
    let loading = false;
    if (!node.state.loaded && !node.state.expanded && !node.state.loading) {
      loading = true;
      this.props.onFetchNode(node);
    }
    onToggleClick(node, !node.state.expanded);
    onChange(updateNode(node, { expanded: !node.state.expanded, loading }));
  }

  onSelect() {
    const { isSelected, onlyLeafSelection, node, onSelect, isDisabled, multi } = this.props;
    if (isDisabled) return;
    if (node.children && (onlyLeafSelection || multi)) {
      this.onToggle();
      return;
    }
    onSelect(node, isSelected);
  }

  renderCheckbox() {
    const { isSelected, isDisabled } = this.props;
    return <Checkbox className="TreeNode__checkbox" disabled={isDisabled} checked={isSelected} />;
  }

  render() {
    const { node, rightArrow, isSelected, itemRenderer, multi } = this.props;
    const nodeForRender = getNodeForRender(node);
    const { svg, svgId } = node;
    const { hasChildren, expanded } = nodeForRender.state;
    const className = classNames('TreeNode', {
      'TreeNode--expanded': hasChildren && expanded,
      'TreeNode--collapsed': hasChildren && !expanded,
      'TreeNode--leaf': !hasChildren,
      'TreeNode--multi': !hasChildren && multi,
      'TreeNode--selected': !multi && isSelected
    });
    const extraProps = {};
    if (isSelected) {
      extraProps['data-testid'] = 'TreeSelection__selected-node';
    }

    return (
      <div className={className}>
        <div className="TreeNode__inner" onClick={this.onSelect} {...extraProps}>
          {itemRenderer({
            ...this.props,
            children: [
              <div className="TreeNode__main" key={`node${node.id}`}>
                {hasChildren &&
                  !rightArrow &&
                  this.renderToggle({ expanded, className: 'TreeNode__toggle--left' })}
                {(svg || svgId) && (
                  <SvgIcon
                    className="TreeSelection__node-icon"
                    width="24px"
                    height="24px"
                    svgId={svgId}
                  >
                    {svgId ? undefined : svg}
                  </SvgIcon>
                )}
                {!hasChildren && multi && this.renderCheckbox(isSelected)}
                <span className="TreeNode__name">{node.headerElement || node.name}</span>
                {hasChildren && rightArrow && this.renderToggle({ expanded })}
              </div>,
              node.sideItems && this.renderSideItems()
            ]
          })}
        </div>
      </div>
    );
  }
}

TreeNode.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  node: treeSelectionNodeShape,
  onFetchNode: PropTypes.func,
  rightArrow: PropTypes.bool,
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onlyLeafSelection: PropTypes.bool,
  multi: PropTypes.bool,
  itemRenderer: PropTypes.func,
  onToggleClick: PropTypes.func
};

TreeNode.defaultProps = {
  onFetchNode: noop,
  onToggleClick: noop,
  isDisabled: false
};
export default TreeNode;
